// extracted by mini-css-extract-plugin
export var attribution = "_b1-4";
export var authorName = "_b1-5";
export var quote = "_b1-3";
export var testimonial = "_b1-2";
export var trustedBy = "_b1-0";
export var trustedByLabel = "_b1-1";